import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=64bfef04&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=64bfef04&prod&lang=scss"
import style1 from "./footer.vue?vue&type=style&index=1&id=64bfef04&prod&lang=scss&scoped=true"
import style2 from "./footer.vue?vue&type=style&index=2&id=64bfef04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bfef04",
  null
  
)

export default component.exports